import { ILogService } from 'angular'
import { CVModel } from 'src/_candidato/data/cv/CVModel'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import { ICuestionario, IICuestionarioBloque, IICuestionarioPreg } from 'src/model/candidato-api'

class EditcvBloqueComponentCtrl {
  bloque!: IICuestionarioBloque<IICuestionarioPreg>
  cuestionario!: ICuestionario
  cvmodel!: CVModel
  params!: { [v: string]: any }

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[EditcvBloqueComponentCtrl] onInit')
  }
}

export default $candidatoPublicMod.component('editcvBloque', {
  bindings: {
    bloque: '<',
    cuestionario: '<',
    cvmodel: '<',
    params: '<',
    verestruct: '<',
    verrespuestas: '<',
  },
  controller: EditcvBloqueComponentCtrl,
  template: require('./editcv-bloque.component.html'),
  //templateUrl: "./editcv-bloque.component.html"
})
